const MfaPanel = ({ mfaConfigured, qrCodeImage, otpCode, onOtpCodeChange, onVerify, onShowReset, onReset, showResetConfirm }) => {
  return (
    <div id="ConfigureMFADiv">
      <h3 className="user-profile-subheading">Multi-Factor Authentication</h3>

      {mfaConfigured ? (
        <div>
          <button type="button" className="btn btn-primary" onClick={onShowReset}>Reset Device MFA</button>

          {showResetConfirm && (
            <div className="user-profile-mfa-confirm">
              <p>Are you sure you want to reset your Multi-Factor Authentication?</p>
              <button type="button" className="btn btn-default" onClick={onShowReset}>No</button>
              <button type="button" className="btn btn-primary" onClick={onReset}>Yes</button>
            </div>
          )}
        </div>
      ) : (
        <div className="user-profile-mfa-setup">
          <h4>Complete the following steps to configure your mobile app.</h4>
          <h5>
            Step 1. Install the Microsoft authenticator app for
            <a target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.azure.authenticator"> android </a>
            or
            <a target="_blank" rel="noreferrer" href="https://apps.apple.com/in/app/microsoft-authenticator/id983156458?l=en"> iOS</a>
          </h5>
          <h5>Step 2. In the app, add an account and choose "Work or school account".</h5>
          <h5>Step 3. Scan the image below.</h5>

          {qrCodeImage ? (
            <img src={`data:image/png;base64,${qrCodeImage}`} alt="QR Code for TOTP" className="user-profile-qr" />
          ) : (
            <p className="user-profile-muted">QR code is not available yet.</p>
          )}

          <div className="user-profile-otp-wrap">
            <label htmlFor="MFAotpCode">Enter Code</label>
            <input
              type="text"
              id="MFAotpCode"
              className="form-control user-profile-otp-input"
              value={otpCode}
              onChange={(e) => onOtpCodeChange(e.target.value)}
              placeholder="Authentication Code"
            />
            <button type="button" className="btn btn-primary user-profile-verify-btn" onClick={onVerify}>Verify</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MfaPanel;
